exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-file-container[data-v-4210ad5a] {\n  border: thin #888 dashed;\n  padding: 30px;\n  background-color: #efefef;\n  font-size: 1.1em;\n}\n.custom-file-upload[data-v-4210ad5a] {\n  width: 100%;\n  padding: 20px;\n  border: thin solid #888;\n  border-radius: 4px;\n}", ""]);

// exports
